// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import actionCreators from "@modules/service/actionCreator";
import * as serviceSelectors from "@modules/service/selectors";
import * as sharedSelectors from "@modules/shared/selectors";
import type { StandardQuestion } from "@modules/service/reducer/standard-questions/types";
import type { HierarchyTree } from "@modules/shared/reducer/hierarchy/types";
import type { StepProps } from "@components";
import { HierarchyScopeForm } from "@modules/service/components/hierarchy-scope";
import type { HierarchyAssignment } from "@modules/service/types";
import type { State } from "@store/reducers";

type PropsFromState = $Exact<{
  container: ?StandardQuestion,
  assignments: Array<HierarchyAssignment>,
  hierarchy: ?HierarchyTree,
  isAssignmentsValid: boolean,
}>;

type PropsFromDispatch = $Exact<{
  setAssignments: typeof actionCreators.SetStandardQuestionAssignments,
}>;

type Props = $Exact<{
  ...StepProps,
  ...PropsFromLocalize,
  ...PropsFromState,
  ...PropsFromDispatch,
}>;

export class Step2HierarchyScope extends React.Component<Props> {
  handleChanges = (data: Array<HierarchyAssignment>) => {
    this.props.setAssignments(data);
  };

  render() {
    if (!this.props.editable) {
      return null;
    }
    return (
      <div className="w-100 d-flex justify-content-center">
        <div className="col-sm-12">
          {this.props.hierarchy && this.props.assignments ? (
            <HierarchyScopeForm
              hierarchy={this.props.hierarchy}
              assignments={this.props.assignments}
              onChange={this.handleChanges}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: State): PropsFromState => {
  return {
    container: serviceSelectors.getStandardQuestionContainer(state),
    assignments: serviceSelectors.getStandardQuestionAssignments(state),
    isAssignmentsValid: serviceSelectors.isStandardQuestionAssignmentsValid(state),
    hierarchy: sharedSelectors.getHierarchyTree(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  setAssignments: actionCreators.SetStandardQuestionAssignments,
};

export default compose(
  localize(),
  connect(mapStateToProps, mapDispatchToProps),
)(Step2HierarchyScope);
